import { useState, useEffect, useRef, Fragment, memo, useMemo } from "react";
import style from "./../index.module.scss";
import styleUi from "./SelectPot.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';

const SelectPot = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    const scrollableRef = useRef(null);
    const contentRef = useRef(null);
    const maskRef = useRef(null);

    useEffect(() => {
        console.log("SelectPot");
        setInProp(true);
        if (scrollableRef.current && maskRef.current) {
            const h = scrollableRef.current.clientHeight;
            maskRef.current.style.minHeight = `${h}px`;
            scrollableRef.current.style.maxHeight = `${h}px`;
            scrollableRef.current.scrollTop = h;
        }
    }, [])

    function updateHeight() {
        if (scrollableRef.current && maskRef.current) {
            const h = contentRef.current.clientHeight;
            maskRef.current.style.minHeight = `${h}px`;
            scrollableRef.current.style.maxHeight = `${h}px`;
            scrollableRef.current.scrollTop = h;
        }
    }
    function releseHand(e) {
        if (scrollableRef.current.scrollTop < scrollableRef.current.clientHeight * .9) {
            scrollableRef.current.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            });
            setTimeout(() => {
                setInProp(false);
            }, 500);
        }
        else
            scrollableRef.current.scrollTo({
                top: scrollableRef.current.clientHeight,
                left: 0,
                behavior: "smooth",
            })
    }

    return (
        <div className={style.modalBottom} style={{ backgroundColor: "#00000055", overflow: "hidden" }}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "SelectPot"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app} ref={scrollableRef} onTouchEnd={e => { releseHand(e) }} onMouseUp={e => { releseHand(e) }} onScroll={e => {
                                if (e.target.scrollTop === 0)
                                    setInProp(false);
                            }}>
                                <div className={styleUi.mask} ref={maskRef}>
                                </div>
                                <div className={styleUi.content} ref={contentRef} >
                                    <div className={styleUi.bg}>
                                        <div className={styleUi.bar}>
                                        </div>
                                    </div>
                                    <div className={styleUi.view}>
                                        <div onClick={e=>{
                                            arg.cb("formMap");
                                            setInProp(false);
                                        }}>
                                            <img src="./assets/ui/map.png" />
                                            <span>從地圖加入</span>
                                        </div>
                                        {/* <div onClick={e=>{
                                            arg.cb("exitsList");
                                            setInProp(false);
                                        }}>
                                        <img src="./assets/ui/save2.png" />
                                            <span>己儲存的地點</span>
                                        </div> */}
                                        <button className={`${allStyle.btnGray3} ${styleUi.next}`} onClick={e => {
                                            setInProp(false);
                                        }}>
                                            取消
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition >
        </div >
    );
}

export default memo(SelectPot);